// extracted by mini-css-extract-plugin
export default {"container":"Map_container__Al18E","map":"Map_map__Ah5Z2"};